import { render } from "./GridGradeSelectorComponent.vue?vue&type=template&id=eef1c260&scoped=true&ts=true"
import script from "./GridGradeSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./GridGradeSelectorComponent.vue?vue&type=script&lang=ts"

import "./GridGradeSelectorComponent.vue?vue&type=style&index=0&id=eef1c260&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef1c260"]])

export default __exports__